<div class="dropdown-icon">
  <ng-template #popContent>
    <ng-content></ng-content>
  </ng-template>
  <fa-icon
    [icon]="faSetting"
    class="icon"
    placement="bottom-right"
    [ngbPopover]="popContent"></fa-icon>
</div>
